import React from 'react';
import { StackLayout } from '@progress/kendo-react-layout';
import { PlayerState, TeamState } from '../../types/state';
import ScoreCard from './score-card';

interface ScoreListProps {
  data?: (PlayerState | TeamState)[];
  isHideAvatar?: boolean;
}

const ScoreList = ({ data = [], isHideAvatar = false }: ScoreListProps) => {
  if (!data || data.length === 0) {
    return (
      <div className={'d-flex justify-content-center align-items-center py-5 text-muted'}>
        <h4 className={'text-secondary'}>No scores available yet</h4>
      </div>
    );
  }

  const scoreCards = [...data]
    .sort((a, b) => (b.score ?? 0) - (a.score ?? 0))
    .map((item, index: number) => (
      <ScoreCard
        key={item.id ?? item.code ?? index}
        rank={index + 1}
        avatarImage={item.avatarImage}
        name={item.name}
        score={item.score ?? 0}
        isHideAvatar={isHideAvatar}
      />
    ));

  return (
    <StackLayout orientation={'vertical'} className={'w-100'}>
      {scoreCards}
    </StackLayout>
  );
};

export default ScoreList;
